import { Avatar, Box, Paper, styled } from "@/components";

const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(1),
  right: theme.spacing(1),
  transition: theme.transitions.create(["transform", "opacity"], {
    duration: theme.transitions.duration.shorter,
  }),
  variants: [
    {
      props: ({ expand = "false" }) => !Boolean(expand.replace(/false/, "")),
      style: {
        transform: "translateY(20vh)",
        opacity: 0,
      },
    },
    {
      props: ({ expand = "false" }) => Boolean(expand.replace(/false/, "")),
      style: {
        transform: "translateY(0)",
        opacity: 1,
      },
    },
  ],
}));

const StyledInfo = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  cursor: "pointer",
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 67,
  height: 67,
  cursor: "pointer",
}));
const StyledCloseButton = styled("button")(({ theme }) => ({
  position: "absolute",
  top: "-8px",
  right: "-8px",
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#000000",
  color: "#ffffff",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  lineHeight: 1,
  fontWeight: "bold",
  padding: 0,
  zIndex: 10,
  transition: theme.transitions.create(["opacity", "transform"], {
    duration: theme.transitions.duration.shorter,
  }),
  "&:hover": {
    opacity: 0.8,
    transform: "scale(1.1)",
  },
  "&:active": {
    transform: "scale(0.95)",
  }
}));

export { StyledBox, StyledInfo, StyledAvatar, StyledCloseButton };
